export default __webpack_public_path__ + "static/media/twitter.77db67a2.svg";